
<app-modal class="manage-tag-container"
           [(visible)]="visible"
           header="{{entityName}} {{headerSet}} Tag">

  <div class="label" *ngIf="createTag">This Tag will not be automatically applied to a Chase, Address or Document but will be available for use.</div>
  <div class="label" *ngIf="editTag">Editing this Tag will change all tags associated with it. Are you sure you want to continue?</div>
  <div class="label" *ngIf="deleteTag">Deleting this Tag will remove it from all {{headerSet}} associated with it. Are you sure you want to continue?</div>
  <div class="label" *ngIf="replaceTag">Replacing this Tag will change all {{headerSet}} associated with it. Are you sure you want to continue?</div>
  <div class="countObj total-count" *ngIf="editTag || deleteTag || replaceTag">TOTAL {{headerSet}}: {{tagObj.totalObject }}</div>
  <div class="formSet">
    <form [formGroup]="tabManagement">

      <div *ngIf="replaceTag">
        <div class="set-input">
          <form-factory [formGroup]="manageTagForm"
                        [model]="currentTagInput"></form-factory>

          <form-factory (onInput)="onInputSearchTag($event)" (onChange)="onChangeTag($event)" [formGroup]="manageTagForm"
                        [model]="replaceTagInput" (keyup)="onkeyUp($event)"></form-factory>
        </div>
      </div>
      <div *ngIf="createTag">
        <div class="set-input">
          <form-factory *ngIf="createTag" [formGroup]="tabManagement"
                        [model]="tagTypeInput"
                        (onChange)="getTagType($event)"></form-factory>

          <form-factory *ngIf="createTag" [formGroup]="tabManagement"
                        [model]="tagInput" (input)="onSearchChange($event.target.value)"></form-factory>
          <app-color-palette-manage [isCreateTagTemplateVisible]="isCreateTagTemplateVisible"
                                    (selectedColor)="onSelectedColor($event)" [isAddColor]="true" [hasTagName]="tagName"></app-color-palette-manage>
        </div>
      </div>

      <div *ngIf="editTag" class="tagEdit set-input">
        <form-factory [formGroup]="tabManagement"
                      [model]="tagInput"></form-factory>
      </div>
      <div *ngIf="deleteTag" class="set-input">
        <form-factory [formGroup]="tabManagement"
                      [model]="deleteTagInput"></form-factory>
      </div>

    </form>
  </div>
  <footer>
    <app-button [disabled]="isCheckForm" classes="secondary confirm"
                text="CONFIRM"
                (onClick)="onTagConfirm()">
    </app-button>
  </footer>
</app-modal>

